import React from 'react'
import styled from 'styled-components'
import Brightness3Icon from '@material-ui/icons/Brightness3'

const NightIcon = styled(Brightness3Icon)`
  transform: rotate(45deg);
`

export default NightIcon